// TODO it's not reliable way, since it's not obvious that name is used for this purpose anybody can overwrite it in XM
export const TIRES_FILTER_GROUP_NAME = 'Tires Navigation'
